import React, { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@material-tailwind/react/Navbar";
import NavbarContainer from "@material-tailwind/react/NavbarContainer";
import NavbarWrapper from "@material-tailwind/react/NavbarWrapper";
import NavbarBrand from "@material-tailwind/react/NavbarBrand";
import NavbarToggler from "@material-tailwind/react/NavbarToggler";
import NavbarCollapse from "@material-tailwind/react/NavbarCollapse";
import Nav from "@material-tailwind/react/Nav";
import NavLink from "@material-tailwind/react/NavLink";
import Dropdown from "@material-tailwind/react/Dropdown";
import DropdownItem from "@material-tailwind/react/DropdownItem";
import Icon from "@material-tailwind/react/Icon";
import Button from "@material-tailwind/react/Button";
import { Label } from "@material-tailwind/react";
import squareimag from "assets/img/vector-square-solid.svg"
import appStoreLogo from "../assets/img/app/appcomingsoon.png";
import vector_tile_source from "../assets/img/vector-square-solid.svg";

export default function DefaultNavbar() {
  const [openNavbar, setOpenNavbar] = useState(false);

  return (
    <div>
      <Navbar
        color="blueGray"
        // color="transparent"
        navbar
        // color="black"
        // class="sticky top-0 z-150"
        navbar
        // className="sticky top-0 z-50"
      >
        <NavbarContainer>
          <img src={vector_tile_source} style={{ height: '50px' }} alt="Logo"/>
          <NavbarWrapper>
            <a href="/" rel="noreferrer">
              {/*<NavbarBrand>*/}
              {/*  <Label color="blueGray">Squarehunters.com</Label>*/}
              {/*  {" "}*/}
              {/*</NavbarBrand>*/}

            </a>
            <NavbarToggler
              onClick={() => setOpenNavbar(!openNavbar)}
              color="white"
            />
          </NavbarWrapper>


          <NavbarCollapse open={openNavbar}>
            <Nav>
              <div className="flex flex-col z-50 lg:flex-row lg:items-center">
                <NavLink href="/" rel="noreferrer" ripple="light">
                  {/*<Icon name="apps" size="2xl" />*/}
                  <Label color="blueGray">Home</Label>
                  {/*&nbsp;Home*/}
                </NavLink>
                {/*<NavLink href="/squaremap" rel="noreferrer" ripple="light">*/}
                {/*  /!*<Icon name="apps" size="2xl" />*!/*/}
                {/*  /!*&nbsp;*!/*/}
                {/*  <Label color="blueGray">Squares Map</Label>*/}
                {/*</NavLink>*/}
                <NavLink href="/everytile" rel="noreferrer" ripple="light">
                  {/*<Icon name="apps" size="2xl" />*/}
                  {/*&nbsp;*/}
                  <Label color="blueGray">EveryTile Helper</Label>
                </NavLink>
                <NavLink href="/tilesize" rel="noreferrer" ripple="light">
                  {/*<Icon name="apps" size="2xl" />*/}
                  {/*&nbsp;*/}
                  <Label color="blueGray">Tile Size</Label>
                </NavLink>
                <div className="text-white">
                  <Dropdown
                    color="transparent"
                    size="sm"
                    buttonType="link"
                    buttonText={
                      <div className="py-2.5 font-medium flex items-center">
                        {/*<Icon name="view_carousel" size="xl" color="white" />*/}
                        {/*<span className="ml-2">Menu</span>*/}
                        <Label color="blueGray">Menu</Label>
                      </div>
                    }
                    ripple="light"
                  >
                    {/*<Link*/}
                    {/*  to={{ pathname: "https://beta.sh2kml.rx48.eu/" }}*/}
                    {/*  target="_blank"*/}
                    {/*>*/}
                    {/*  <DropdownItem color="lightBlue">Beta</DropdownItem>*/}
                    {/*</Link>*/}
                    <Link to="/setLocation">
                      <DropdownItem color="lightBlue">
                        Set Location
                      </DropdownItem>
                    </Link>
                    {/*<Link to="/register">*/}
                    {/*    <DropdownItem color="lightBlue">*/}
                    {/*        Register*/}
                    {/*    </DropdownItem>*/}
                    {/*</Link>*/}
                  </Dropdown>
                </div>
                {/*<NavLink*/}
                {/*    href="https://github.com/creativetimofficial/material-tailwind?ref=mtk"*/}
                {/*    target="_blank"*/}
                {/*    rel="noreferrer"*/}
                {/*    ripple="light"*/}
                {/*>*/}
                {/*    <Icon*/}
                {/*        family="font-awesome"*/}
                {/*        name="fab fa-github"*/}
                {/*        size="xl"*/}
                {/*    />*/}
                {/*    &nbsp;Github*/}
                {/*</NavLink>*/}
                {/*<NavLink*/}
                {/*    href="https://github.com/creativetimofficial/material-tailwind/issues?ref=mtk"*/}
                {/*    target="_blank"*/}
                {/*    rel="noreferrer"*/}
                {/*    ripple="light"*/}
                {/*>*/}
                {/*    Issues*/}
                {/*</NavLink>*/}
                {/*<a*/}
                {/*    href="https://www.creative-tim.com/product/material-tailwind-kit-react"*/}
                {/*    target="_blank"*/}
                {/*    rel="noreferrer"*/}
                {/*>*/}
                {/*    <Button*/}
                {/*        color="transparent"*/}
                {/*        className="bg-white text-black ml-4"*/}
                {/*        ripple="dark"*/}
                {/*    >*/}
                {/*        Free Download*/}
                {/*    </Button>*/}
                {/*</a>*/}
              </div>
            </Nav>
          </NavbarCollapse>
        </NavbarContainer>
      </Navbar>
    </div>
  );
}
